import React, { useState } from 'react';
import Icon from '../AppIcon';
import Button from './Button';

const ExportActionCenter = ({ onExport }) => {
  const [isExporting, setIsExporting] = useState(false);
  const [exportType, setExportType] = useState(null);

  const exportOptions = [
    {
      id: 'performance-report',
      title: 'Performance Report',
      description: 'Detailed PDF with analytics and insights',
      icon: 'FileText',
      iconBg: 'bg-primary',
      format: 'PDF'
    },
    {
      id: 'results-csv',
      title: 'Results Data',
      description: 'Export test results in CSV format',
      icon: 'Table',
      iconBg: 'bg-secondary',
      format: 'CSV'
    },
    {
      id: 'certificate',
      title: 'Certificate',
      description: 'Generate completion certificate',
      icon: 'Award',
      iconBg: 'bg-success',
      format: 'PDF'
    },
    {
      id: 'study-progress',
      title: 'Study Progress',
      description: 'Export learning journey timeline',
      icon: 'TrendingUp',
      iconBg: 'bg-accent',
      format: 'PDF'
    }
  ];

  const handleExport = async (option) => {
    setIsExporting(true);
    setExportType(option?.id);

    try {
      if (onExport) {
        await onExport(option);
      } else {
        await new Promise(resolve => setTimeout(resolve, 2000));
        console.log(`Exporting ${option?.title} as ${option?.format}`);
      }
    } catch (error) {
      console.error('Export failed:', error);
    } finally {
      setIsExporting(false);
      setExportType(null);
    }
  };

  return (
    <div className="export-action-center animate-fade-in">
      <div className="export-header">
        <h2 className="export-title">Export Options</h2>
        <p className="export-description">
          Download your reports and certificates
        </p>
      </div>
      <div className="export-options">
        {exportOptions?.map((option) => (
          <div key={option?.id} className="export-option">
            <div className="export-option-info">
              <div className={`export-option-icon ${option?.iconBg}`}>
                <Icon name={option?.icon} size={20} color="white" />
              </div>
              <div className="export-option-details">
                <span className="export-option-title">{option?.title}</span>
                <span className="export-option-description">{option?.description}</span>
              </div>
            </div>

            <Button
              variant="outline"
              size="sm"
              onClick={() => handleExport(option)}
              disabled={isExporting}
              loading={isExporting && exportType === option?.id}
              iconName="Download"
              iconPosition="left"
            >
              {option?.format}
            </Button>
          </div>
        ))}
      </div>
    </div>
  );
};

export default ExportActionCenter;